import { useClonedTracker } from './hooks';
import { XrayPanelContext } from './XrayPanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const XrayPanelContextProvider = ({
  auth,
  tracker,
  children
}) => {
  const clonedTracker = useClonedTracker(tracker);
  return /*#__PURE__*/_jsx(XrayPanelContext.Provider, {
    value: {
      auth,
      tracker: clonedTracker
    },
    children: children
  });
};